<template>
  <div ref="main" class="d-flex flex-column">
    <div ref="tableupper" :style="tableupper_style">
      <lazy-list-x
        ref="horizontalheader"
        class="h-100"
        :style="horizontal_header_style"
        :render="horizontal_header_render"
        @initialize="horizontal_header_initialize"
        @updated="horizontal_header_updated"
      >
        <template #default="scope"
          ><slot name="horizontalheader" v-bind="add_width(scope)"></slot
        ></template>
      </lazy-list-x>
    </div>
    <div ref="tablelower" class="d-flex flex-row" :style="tablelower_style">
      <lazy-list-y
        ref="verticalheader"
        :style="vertical_header_style"
        :render="vertical_header_render"
        @initialize="vertical_header_initialize"
        @updated="vertical_header_updated"
        ><template #default="scope"
          ><slot name="verticalheader" v-bind="add_height(scope)"></slot
        ></template>
      </lazy-list-y>
      <lazy-table-xy
        ref="body"
        :style="body_style"
        container="div"
        :renderx="body_renderx"
        :rendery="body_rendery"
        @initialize="body_initialize"
        @updated="body_updated"
        @scrollxy="scrollxy"
        ><template #default="scope"
          ><slot
            name="bodycell"
            v-bind="add_width_and_height(scope)"
          ></slot></template
      ></lazy-table-xy>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import Vue from 'vue'

import {
  vue_lazy_scroller_logicx,
  vue_lazy_scroller_logicy,
} from '@/components/lazy_compute.js'

import LazyListX from '@/components/lazy_list_x.vue'
import LazyListY from '@/components/lazy_list_y.vue'
import LazyTableXy from '@/components/lazy_table_xy.vue'

// *****************************************************************************

export default {
  name: 'LazyDisplayFrozenpanetableXY',
  components: {
    LazyListX,
    LazyListY,
    LazyTableXy,
  },
  props: [
    'default_width',
    'default_height',
    'nbx',
    'nby',
    'variable_width_start_pos',
    'variable_widths',
    'variable_height_start_pos',
    'variable_heights',
    'horizontal_header_height',
    'vertical_header_width',
    'vertical_header_containee_class',
    'horizontal_header_containee_class',
    'body_containee_x_class',
    'body_containee_y_class',
  ],

  data() {
    return {
      scrollbar_dimensions: { width: 0, height: 0 },
      renderx: {
        padding_low: 0,
        padding_high: 0,
        really_rendered_size: 0,
        component_start: 0,
        component_stop: 0,
      },
      rendery: {
        padding_low: 0,
        padding_high: 0,
        really_rendered_size: 0,
        component_start: 0,
        component_stop: 0,
      },
      horizontal_header_initialized: false,
      vertical_header_initialized: false,
      body_initialized: false,
      running: false,
    }
  },

  my_lazy_list_handlerx: null,
  my_lazy_list_handlery: null,
  horizontal_header_element: null,
  vertical_header_element: null,

  computed: {
    _() {
      return _
    },
    tableupper_style() {
      return {
        height: this.horizontal_header_height + 'px',
        'margin-left': this.vertical_header_width + 'px',
        'margin-right': this.scrollbar_dimensions.width + 'px',
        flex: '0 0 auto',
      }
    },
    tablelower_style() {
      return { flex: '1 1 0px', 'min-height': '0px' }
    },
    horizontal_header_style() {
      return {}
    },
    vertical_header_style() {
      return {
        width: this.vertical_header_width + 'px',
        'margin-bottom': this.scrollbar_dimensions.height + 'px',
        flex: '0 0 auto',
      }
    },
    body_style() {
      return { flex: '1 1 0px', 'min-width': '0px' }
    },
    horizontal_header_render() {
      let res = _.cloneDeep(this.renderx)
      res.container = 'div'
      res.container_class = this.horizontal_header_containee_class
      res.scroll = false
      res.initialized = this.initialized
      return res
    },
    vertical_header_render() {
      let res = _.cloneDeep(this.rendery)
      res.container = 'div'
      res.container_class = this.vertical_header_containee_class
      res.scroll = false
      res.initialized = this.initialized
      return res
    },
    body_renderx() {
      let res = _.cloneDeep(this.renderx)
      res.container = 'div'
      res.container_class = this.body_containee_x_class
      res.scroll = true
      res.initialized = this.initialized
      return res
    },
    body_rendery() {
      let res = _.cloneDeep(this.rendery)
      res.container = 'div'
      res.container_class = ['d-flex', 'flex-row'].concat(
        this.body_containee_y_class
      )
      res.scroll = true
      res.initialized = this.initialized
      return res
    },
    initialized() {
      return (
        this.horizontal_header_initialized &&
        this.vertical_header_initialized &&
        this.body_initialized
      )
    },
  },
  watch: {
    nbx(nv, ov) {
      if (nv !== ov) {
        this.$options.my_lazy_list_handlerx.set_nb_elements(nv)
        this.$options.my_lazy_list_handlerx.relayout()
      }
    },
    nby(nv, ov) {
      if (nv !== ov) {
        this.$options.my_lazy_list_handlery.set_nb_elements(nv)
        this.$options.my_lazy_list_handlery.relayout()
      }
    },
    variable_width_start_pos(nv, ov) {
      if (nv !== ov) {
        this.$options.my_lazy_list_handlerx.set_variable_size_start_pos(nv)
        this.$options.my_lazy_list_handlerx.relayout()
      }
    },
    variable_widths(nv) {
      this.$options.my_lazy_list_handlerx.set_variable_sizes(nv)
      this.$options.my_lazy_list_handlerx.relayout()
    },
    variable_height_start_pos(nv, ov) {
      if (nv !== ov) {
        this.$options.my_lazy_list_handlery.set_variable_size_start_pos(nv)
        this.$options.my_lazy_list_handlery.relayout()
      }
    },
    variable_heights(nv) {
      this.$options.my_lazy_list_handlery.set_variable_sizes(nv)
      this.$options.my_lazy_list_handlery.relayout()
    },
    'renderx.component_start': function() {
      this.fetch_data()
    },
    'renderx.component_stop': function() {
      this.fetch_data()
    },
    'rendery.component_start': function() {
      this.fetch_data()
    },
    'rendery.component_stop': function() {
      this.fetch_data()
    },
  },

  created() {
    // created is the ideal place for initializing the non reactive
    // data because props/data are available but the html element
    // has not yet been inserted
    this.$options.my_lazy_list_handlerx = new vue_lazy_scroller_logicx(
      this.renderx,
      this.default_width,
      this.nbx || 0
    )
    this.$options.my_lazy_list_handlery = new vue_lazy_scroller_logicy(
      this.rendery,
      this.default_height,
      this.nby || 0
    )
    this.$options.my_lazy_list_handlerx.set_variable_size_start_pos(
      this.variable_width_start_pos
    )
    this.$options.my_lazy_list_handlery.set_variable_size_start_pos(
      this.variable_height_start_pos
    )
    this.$options.my_lazy_list_handlerx.set_variable_sizes(this.variable_widths)
    this.$options.my_lazy_list_handlery.set_variable_sizes(
      this.variable_heights
    )
  },

  mounted() {
    this.determine_scrollbar_dimensions()
    this.running = true
    this.$options.my_lazy_list_handlerx.set_nb_elements(this.nbx)
    this.$options.my_lazy_list_handlery.set_nb_elements(this.nby)
    this.$options.my_lazy_list_handlerx.relayout()
    this.$options.my_lazy_list_handlery.relayout()
  },

  beforeDestroy() {
    this.running = false
  },

  methods: {
    determine_scrollbar_dimensions() {
      let cont = this.$parent.$el
      let scrollBarDeterminer = document.createElement('div')
      scrollBarDeterminer.setAttribute(
        'style',
        'width: 100px; height: 100px; overflow: scroll; visibility: hidden'
      )
      let scroller = document.createElement('div')
      scroller.setAttribute(
        'style',
        'position: relative; width: 10000px; height: 10000px;'
      )

      scrollBarDeterminer.appendChild(scroller)
      cont.appendChild(scrollBarDeterminer)

      let width =
        scrollBarDeterminer.offsetWidth - scrollBarDeterminer.clientWidth
      let height =
        scrollBarDeterminer.offsetHeight - scrollBarDeterminer.clientHeight
      cont.removeChild(scrollBarDeterminer)

      this.scrollbar_dimensions = { width, height }
    },
    horizontal_header_initialize(main_elt, test_elt) {
      this.$options.horizontal_header_element = main_elt
      this.horizontal_header_initialized = true
    },
    vertical_header_initialize(main_elt, test_elt) {
      this.$options.vertical_header_element = main_elt
      this.vertical_header_initialized = true
    },
    body_initialize(main_elt, test_elt) {
      this.renderx.used_default_size = this.$options.my_lazy_list_handlerx.initialize(
        main_elt,
        test_elt
      )
      this.rendery.used_default_size = this.$options.my_lazy_list_handlery.initialize(
        main_elt,
        test_elt
      )
      this.body_initialized = true
    },
    scrollxy() {
      this.$options.my_lazy_list_handlerx.handle_scroll()
      this.$options.my_lazy_list_handlerx.replicate(
        this.$options.horizontal_header_element
      )
      this.$options.my_lazy_list_handlery.handle_scroll()
      this.$options.my_lazy_list_handlery.replicate(
        this.$options.vertical_header_element
      )
    },
    fetch_data() {
      if (this.running) {
        this.$emit(
          'fetch_data',
          this.renderx.component_start,
          this.renderx.component_stop,
          this.rendery.component_start,
          this.rendery.component_stop
        )
      }
    },
    add_width(scope) {
      const nb = scope.nbx
      let res = this.renderx.used_default_size
      if (
        !_.isUndefined(this.variable_width_start_pos) &&
        !_.isUndefined(this.variable_widths) &&
        this.variable_widths.length !== 0
      ) {
        if (
          nb >= this.variable_width_start_pos &&
          nb < this.variable_width_start_pos + this.variable_widths.length
        ) {
          res = this.variable_widths[nb - this.variable_width_start_pos]
        }
      }
      Vue.set(scope, 'width', `width:${res}px;`)
      return scope
    },
    add_height(scope) {
      const nb = scope.nby
      let res = this.rendery.used_default_size
      if (
        !_.isUndefined(this.variable_height_start_pos) &&
        !_.isUndefined(this.variable_heights) &&
        this.variable_heights.length !== 0
      ) {
        if (
          nb >= this.variable_height_start_pos &&
          nb < this.variable_height_start_pos + this.variable_heights.length
        ) {
          res = this.variable_heights[nb - this.variable_height_start_pos]
        }
      }
      Vue.set(scope, 'height', `height:${res}px;`)
      return scope
    },
    add_width_and_height(scope) {
      this.add_width(scope)
      this.add_height(scope)
      return scope
    },
    horizontal_header_updated() {
      this.$options.my_lazy_list_handlerx.adjust_scroll()
    },
    vertical_header_updated() {
      this.$options.my_lazy_list_handlery.adjust_scroll()
    },
    body_updated() {
      this.$options.my_lazy_list_handlerx.adjust_scroll()
      this.$options.my_lazy_list_handlery.adjust_scroll()
    },
  },
}
</script>
